import React,{useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {AiOutlineDelete, AiOutlineEdit} from 'react-icons/ai';
import SettingsMenu from '../staticscreens/SettingsMenu';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { Modal } from 'antd';
import { toast } from 'react-hot-toast';
import { GetClassHomePageDataService, DeleteClassHomePageDataService } from '../../services/class_booking/classHomePageDataServices';

function ClassHomePageDataList() {
  
  const [data,setdata] = useState([])  
  const [selectedData,setselectedData] = useState({})
  const [delete_modal,setdelete_modal] = useState(false)
  const navigate = useNavigate() 


  useEffect(()=>{
    getData()
  },[])  

  
  
    async function getData(){
      const response = await GetClassHomePageDataService();
      setdata(response.data?.data)
    }
  
  
  
    async function deleteData(){
    const response = await DeleteClassHomePageDataService(selectedData?._id)
    if(response?.status === 200){
      getData()
      setdelete_modal(false)
      toast?.success("Deleted Successfully")
      setselectedData({})
    }else{
      getData()
      setdelete_modal(false)
      toast?.success("Deleted Successfully")
      setselectedData({})
    }
   }


  return (
    <div className='md:h-screen pt-5 md:pt-0 md:overflow-hidden'>     

     
      <Modal 
        open={delete_modal}
        closable={false}
        footer={false}
        width={300}>
        <div className='relative'>
        <h6 className="font-bold text-[15px] mb-2 w-full">Delete Data</h6>
        <h6 className='bg-slate-100 text-[12px] p-1.5 font-[400]'>Are you sure to want to delete the data of the <span className='font-[700]'>[{selectedData?.plan}]</span> once deleted it will be not retrieved! </h6>

        <div className='flex justify-end mt-3 '>
        {/* <div className='mr-1 w-full'> */}
        <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setdelete_modal(false)} />
        {/* </div> */}
        <div className='ml-2'>
        <ButtonFilledAutoWidth btnName={'Confirm'} onClick={deleteData} /> 
 </div>
 </div>
 </div>
 </Modal>
      <div className='md:flex items-start'>
      <SettingsMenu />
      <div  className='md:w-[90%] px-4 pt-2 md:pt-2'>
       <div>
        <div className='flex flex-col md:flex-row md:items-center md:justify-between border-b pb-2 gap-2'>
        <div className='flex items-center justify-between'>
        <h6 className='font-[800] text-[14px] '>{'Home Page Data'}<span className='text-[11px]'> ( Classwise ) </span> ({data?.length})</h6>
        </div>

        <div className='flex items-center'>
        <ButtonFilledAutoWidth btnName="Add New" onClick={()=>navigate('create')}   />
        </div>

       </div>

       {data?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] text-center w-[70%] text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any home page data yet, click Add New to create one.</h6>
       </div>
       }
        {data?.length > 0 &&
              <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-2 mt-3'>
                  {data?.map((d,i)=>(
                  <div key={i}  className='border rounded-md items-center relative justify-between px-3 py-2.5'>
                      <h6 className='text-[13px] font-[600] pr-12'>{d?.title} <span className='font-[400] text-[11px] text-slate-600'>/ {d?.class?.label}</span></h6>
                      <h6 className='text-[12px] font-[400] mt-1'>{d?.description}</h6>
                      <h6 className='text-[10px] mt-2 flex flex-wrap gap-1.5 cursor-pointer font-[500] '>
                        <span className='bg-blue-100 rounded px-2 py-1' onClick={()=>window.open(process.env.REACT_APP_BACKEND_IMAGE_URL + d?.video)}>Play Video</span>
                        <span className='bg-orange-100 rounded px-2 py-1' onClick={()=>window.open(process.env.REACT_APP_BACKEND_IMAGE_URL + d?.image)}>Show Thumbnail</span>
                      </h6>
                      <h6 className='text-[10px] font-[400] bg-slate-100 rounded mt-2 p-1'>Created At : <span className='text-[10px] font-[600] leading-normal'>{moment(d.createdAt).format('LLL')}</span> </h6>
                      <div className='absolute right-1 top-1 flex'>
                       <span className='p-2 -m-1 cursor-pointer'><AiOutlineEdit size={16} onClick={()=>{navigate('edit',{state:d})}}/></span>
                       <span className='p-2 -m-1 cursor-pointer'><AiOutlineDelete size={16} onClick={()=>{setselectedData(d);setdelete_modal(true)}}/></span>
                      </div>
                  </div>
                  ))}
              </div>}
       </div>

      



      </div>
      </div> 
    </div>
  )
}

export default ClassHomePageDataList